import { render, staticRenderFns } from "./ui.vue?vue&type=template&id=c3c549f8&scoped=true"
import script from "./ui.vue?vue&type=script&lang=js"
export * from "./ui.vue?vue&type=script&lang=js"
import style0 from "./ui.vue?vue&type=style&index=0&id=c3c549f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c549f8",
  null
  
)

export default component.exports